// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_faded_square_groove/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_faded_square_groove: ModuleSchema = {
  "id": "core_faded_square_groove",
  "uniqueId": "B3D_GRV04",
  "createdAt": "2026-10-10T15:43:48.707Z",
  "updatedAt": "2026-10-10T15:43:48.708Z",
  "label": "Faded Square Groove",
  "description": "Rãnh vuông lõm chạy dọc, thu nhỏ/fade ở hai đầu.",
  "category": "core_geometry",
  "tags": [
    "core",
    "geometry",
    "groove",
    "square",
    "fade"
  ],
  "sliders": [
    {
      "key": "radius",
      "label": "Shell Radius",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 28,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Shell Height",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 24,
      "unit": "mm"
    },
    {
      "key": "grooveCount",
      "label": "Number of Faded Grooves",
      "min": 0,
      "max": 48,
      "step": 1,
      "default": 24
    },
    {
      "key": "endMargin",
      "label": "Groove End Margin",
      "min": 0,
      "max": 12,
      "step": 0.5,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "grooveWidth",
      "label": "Groove Width",
      "min": 0.4,
      "max": 8,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    },
    {
      "key": "grooveDepth",
      "label": "Groove Depth",
      "min": 0,
      "max": 10,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "shell",
      "label": "Faded Square Groove",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "name": "Faded Square Groove",
      "parts": [
        {
          "name": "Faded Square Groove",
          "groupId": 0
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "name": "Faded Square Groove",
      "groupId": 0
    }
  ]
};
